import * as React from "react";
import { FeedItemReview } from "../../../server/feed/buildfeed";
import {
  FeedElementContainer,
  ActionPanel,
} from "../DesignSystem/formatting/FeedComponents";
import { LinkToUser } from "../DesignSystem/LinkToUser";
import { RLink } from "../DesignSystem/RLink";
import { FormattedText } from "../DesignSystem/FormattedText";
import { DateWithTooltip } from "../DesignSystem/DateWithTooltip";

export const FeedElementReview = ({ item }: { item: FeedItemReview }) => {
  const content = item.review;

  return (
    <FeedElementContainer
      href={`/entry/${item.entry_id}`}
      avatars={[
        { username: item.user.username, avatar_url: item.user.avatar_url },
      ]}
      icon={"comment"}
      title={
        <>
          <LinkToUser linkUser={{ username: item.user.username }} />
          <span className="text-slate-500 dark:text-slate-400"> reviewed </span>
          <RLink white to={"/entry/" + item.entry_id}>{item.entry_title}</RLink>
        </>
      }
      subtitle={<DateWithTooltip date={new Date(item.created)} />}
      bottom={<ActionPanel seePost={{ url: `/entry/${item.entry_id}` }} />}
    >
      <FormattedText text={content} maxLength={1000} />
    </FeedElementContainer>
  );
};
